import { render, staticRenderFns } from "./LoadRateSnippet.vue?vue&type=template&id=35180530"
import script from "./LoadRateSnippet.vue?vue&type=script&lang=js"
export * from "./LoadRateSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports